const QUERIES = {
  USERS_LIST: 'users-list',
  SKILLS_LIST: 'skills-list',
  INTERESTS_LIST: 'interests-list',
  CATEGORYS_LIST: 'categorys-list',
  ROLES_LIST: 'roles-list',
  JOBS_LIST: 'jobs-list',
  REELS_LIST: 'reels-list',
  QUIZ_LIST: 'quiz-list',
  NOTIFICATIONS_LIST: 'notifications-list'

}

export {QUERIES}
